const React = require('react');

function convertChildren(children, key, props) {
  let node;
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child && child.key == key) {
        const propsContact = props ? Object.assign({}, child.props, props) : child.props;
        node = React.cloneElement(child, propsContact);
        break;
      }
    }
  }
  return node;
}

module.exports = { convertChildren };
